const limit = lengthLimit => name =>
  name > lengthLimit ? name.substring(0, lengthLimit) + '...' : name;

export { limit };
